import { Component, OnInit, Inject, ViewChild, ChangeDetectorRef, ElementRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { MailInfo } from 'projects/app-misc/src/app/modules/email/data/mail-info';
import { ProjectService } from 'projects/app-misc/src/app/modules/project-misc/data/project/project.service';
import { API_URL } from 'projects/core/src/public-api';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-pdf-preview-dialog',
  templateUrl: './pdf-preview-dialog.component.html',
  styleUrls: ['./pdf-preview-dialog.component.scss'],
  providers: [DeviceDetectorService]
})
export class PdfPreviewDialogComponent implements OnInit {
  mailData: MailInfo;

  googleLink: SafeUrl;

  dialogHeader: string;
  link: string;

  urlLink: string;

  showLoadingSpinner = false;

  showSendButton = true;

  blobUrl: any;

  enablePinchOnMobile: boolean;

  fullScreenStatus = false;

  pdfUrl: SafeUrl;

  constructor(
    private snackBar: MatSnackBar,
    @Inject(API_URL) protected apiUrl: string,
    protected projectService: ProjectService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected deviceDetector: DeviceDetectorService,
    protected el: ElementRef,
    private http: HttpClient, // TODO MOVE TO SERVICE
    protected _sanitizer: DomSanitizer,
    protected dialogRef: MatDialogRef<PdfPreviewDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {
      dialogHeader: string,
      link: string,
      showSendButton: boolean;
    }
  ) {
    this.dialogHeader = data.dialogHeader;
    this.link = data.link;

    this.showSendButton = data.showSendButton;


    this.urlLink = `${this.apiUrl}${this.link}`;

    this.pdfUrl = this._sanitizer.bypassSecurityTrustResourceUrl(this.urlLink)

    this.showLoadingSpinner = true;

    this.downloadFile(this.urlLink).subscribe(
      (res) => {
        this.showLoadingSpinner = false;
        this.blobUrl = res;

      }, error => {
        this.showLoadingSpinner = false;
        this.openSnackBar('Error! File not found.')
        this.dialogRef.close();
      }
    );
  }

  private downloadFile(url: string): any {
    return this.http.get(url, {responseType: 'blob'})
    .pipe(
      map((result: any) => {
        return result;
      })
    );
  }

  fullScreen() {
    this.fullScreenStatus = !this.fullScreenStatus;
    if(this.fullScreenStatus) {
      (this.el.nativeElement as HTMLElement).parentElement.parentElement.classList.add('FULLSCREEN-DIALOG')
    } else {
      (this.el.nativeElement as HTMLElement).parentElement.parentElement.classList.remove('FULLSCREEN-DIALOG')
    }
  }

  ngOnInit() {
    if(this.deviceDetector.isMobile() || this.deviceDetector.isTablet()) {
      this.enablePinchOnMobile = true;
      this.fullScreen();
    }
  }

  openSnackBar(message: string, duration = 5000) {
    this.snackBar.open(message, '', {
      duration,
      panelClass: 'error-snackbar',
      verticalPosition: 'top',
    });
  }

  openPdfInNewTab() {
    window.open(this.urlLink)
  }

}
